import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { Tooltip } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import type { WebhookDelivery } from 'src/interfaces/webhook'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  delivery: WebhookDelivery
  onViewDetails(delivery: WebhookDelivery): void
}

/**
 * A row with exactly one action, "view": the same 36×28 white box as `RowActionsMenu`'s "⋯"
 * trigger, but with an eye glyph that opens the details modal directly — a one-item menu
 * would be a click for nothing.
 */
const WebhookDeliveryActionsCellComponent = ({ delivery, onViewDetails }: Props) => {
  const handleViewDetails = useCallback(() => {
    onViewDetails(delivery)
  }, [delivery, onViewDetails])

  return (
    <div css={tw`flex h-full w-full flex-row items-center justify-end`}>
      <Tooltip title="View details">
        <span>
          <Button
            size="tiny"
            color="white"
            aria-label="View delivery details"
            leftIcon={<GSIcon iconName="gs_eye_open" size={20} css={tw`text-shades-1000`} />}
            onClick={handleViewDetails}
            data-testid={`webhook-delivery-details-${delivery.id}`}
          />
        </span>
      </Tooltip>
    </div>
  )
}

export const WebhookDeliveryActionsCell = memo(WebhookDeliveryActionsCellComponent)
